import React from "react";
import PageTemplate from "../../components/PageTemplate";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { menuList } from "../../utils/menu";

const Design = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTemplate title={t(menuList[3].title)} menuList={menuList[3].list} backgroundImage="/imgs/bg_design" />
      <div className="design_wrap" style={{ maxWidth: 1920, width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Outlet />
      </div>
    </>
  );
};

export default Design;
